import { render, staticRenderFns } from "./fav.vue?vue&type=template&id=a55e4c0e&"
import script from "./fav.vue?vue&type=script&lang=js&"
export * from "./fav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports